<div class="login-card">
  <img src="/assets/TOSAKA_hen_white.png" width="288px" height="200px">
</div>
